<web-settings-breadcrumbs>
    <div class="breadcrumb-icon">
        <a (click)="onCancel()">
            <img src="./assets/img/websites/lpc-back-icon.svg" class="first-breadcrumb-icon" alt="lpc-back-icon" />
        </a>
    </div>
    <div class="breadcrumb-text">
        <span>{{ "shop_cart_icon_style" | translate }}</span>
    </div>
</web-settings-breadcrumbs>

<sp-shop-cart-icon-settings></sp-shop-cart-icon-settings>
